import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-alerts',
  templateUrl: './create-alerts.component.html',
  styleUrls: ['./create-alerts.component.css']
})
export class CreateAlertsComponent implements OnInit {
  activeTab = "general"
  form: FormGroup;
  customCategory: FormArray;
  submitted = false
  errorMessage
  website

  reg = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/;


  constructor(private authService: AuthservicesService, private fb: FormBuilder, private router: Router) { }
  ngOnInit(): void {
    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      link: ['', Validators.pattern(this.reg)],
      type: ['', Validators.required]
    })
  }
  get f() {
    return this.form.controls;
  }
  getScrollTo(id: string) {
    this.activeTab = id
    this.submitted = false;

    if (id == 'general') {
      this.form.reset();
      this.form.get('type').setValue('generalMessage')
    }
    if (id == 'important') {
      this.form.reset();
      this.form.get('type').setValue('importantUpdate')
    }
    if (id == 'urgent') {
      this.form.reset();
      this.form.get('type').setValue('emergencyUpdate')
    }

    const element = this.getElementById(id)
  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }
  onSubmit() {
    this.submitted = true;
    if (this.activeTab == 'general') {
      this.form.get('type').setValue('generalMessage')
    }
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    this.authService.createAlerts(this.form.value).subscribe((res: any) => {
      this.messageAlert(res.message.message, 'success')
      this.router.navigate(['/alerts'])
    },
      error => {
        this.messageAlert(error.error.message, 'error')
      })

  }

  messageAlert(message, type) {
    this.authService.successMessage(message, type)
  }


  checkUrl(value) {
this.website = ''
    let res = value.includes('https://')

    if (res) {
      return this.website = value
    }
    else if (!res) {
      this.website = `https://${value}`
      return this.website
    }
  }
}
